import { RequirePermission } from '@saniplus/ui';

import { PermissionFallback } from '../../../components/shared/PermissionFallback';

/**
 * Every `Heures` route needs `timesheet:read` — the permission the API itself
 * requires on all four reads.
 *
 * The guard is not a security control (the server answers on its own); it
 * exists so the UI never offers a door that is already locked, and it renders
 * an explanation rather than redirecting, because silently sending someone
 * elsewhere reads as a broken link.
 */
export function HeuresGate() {
  return <RequirePermission permission="timesheet:read" fallback={<PermissionFallback />} />;
}
